"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptFlow = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./AcceptFlowComponent.css"));
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var FormScreen_1 = require("./ReactComponents/FormScreen");
var DoneScreen_1 = require("./ReactComponents/DoneScreen");
var AcceptFlowContextProvider_1 = require("./AcceptFlowContextProvider");
var StripeContext_1 = require("./ReactComponents/StripeContext");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var PaymentDetailsScreen_1 = require("./ReactComponents/PaymentDetailsScreen");
var GroupAcceptScreen_1 = require("./ReactComponents/GroupAcceptScreen");
var PreviewAccept_1 = __importStar(require("./ReactComponents/PreviewAccept"));
var Utils_1 = require("./ReactComponents/Utils");
var AcceptScreen;
(function (AcceptScreen) {
    AcceptScreen["Form"] = "form";
    AcceptScreen["Done"] = "done";
    AcceptScreen["PaymentDetails"] = "paymentDetails";
    AcceptScreen["PaymentDetailsDone"] = "paymentDetailsDone";
    AcceptScreen["Group"] = "group";
})(AcceptScreen || (AcceptScreen = {}));
var AcceptFlow = function (_a) {
    var onClose = _a.onClose, onSubmitForm = _a.onSubmitForm, settings = _a.settings, autofillEnabled = _a.autofillEnabled, isPreviewAccept = _a.isPreviewAccept, isStripeIntegrationEnabled = _a.isStripeIntegrationEnabled, stripePublicKey = _a.stripePublicKey, stripeUserId = _a.stripeUserId, postAcceptRedirectUrl = _a.postAcceptRedirectUrl, auditTrailPdfUrl = _a.auditTrailPdfUrl, optOutSpringboard = _a.optOutSpringboard, isPrintMode = _a.isPrintMode, isSimpleMode = _a.isSimpleMode, isCollaboratorPage = _a.isCollaboratorPage, isTemplateGallery = _a.isTemplateGallery, consumerDataServiceUrl = _a.consumerDataServiceUrl, telemetry = _a.telemetry, accepters = _a.accepters, _b = _a.autoScrollIntoView, autoScrollIntoView = _b === void 0 ? true : _b, requiresQuoteChoice = _a.requiresQuoteChoice, renderPaymentFormError = _a.renderPaymentFormError, hideHeader = _a.hideHeader;
    var startScreen;
    if (isPrintMode) {
        startScreen = AcceptScreen.Form;
    }
    else if (settings.accepters.number > 1) {
        startScreen = AcceptScreen.Group;
    }
    else {
        startScreen = AcceptScreen.Form;
    }
    var _c = __read((0, react_1.useState)(startScreen), 2), screen = _c[0], setScreen = _c[1];
    var _d = __read((0, react_1.useState)(undefined), 2), accepterName = _d[0], setAccepterName = _d[1];
    var _e = __read((0, react_1.useState)(undefined), 2), accepterIndex = _e[0], setAccepterIndex = _e[1];
    var wrapperRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!wrapperRef.current || isPrintMode || !autoScrollIntoView) {
            return;
        }
        (0, scroll_into_view_if_needed_1.default)(wrapperRef.current, { behavior: "smooth", scrollMode: "if-needed", block: "start" });
        (0, Utils_1.focusFirstAcceptFlowElement)();
    }, [screen, isPrintMode]);
    (0, react_1.useEffect)(function () {
        if (settings.accepters.number === 1 &&
            settings.accepters.prefilledNames &&
            settings.accepters.prefilledNames.length > 0) {
            var blockSettingsName = settings.accepters.prefilledNames[0];
            setAccepterName(blockSettingsName);
        }
    }, [settings.accepters]);
    var payNowEnabled = settings.payNow.enabled && isStripeIntegrationEnabled;
    var handleAccepterClick = function (accepterData, index) {
        if (accepterData) {
            setAccepterName(accepterData.name);
        }
        if (index !== undefined) {
            setAccepterIndex(index);
        }
        setScreen(AcceptScreen.Form);
    };
    var _f = __read((0, react_1.useState)(!!settings.accepters.finalisedAccepters
        ? settings.accepters.number - settings.accepters.finalisedAccepters.length
        : settings.accepters.number), 2), incompleteAccepterCount = _f[0], setIncompleteAccepterCount = _f[1];
    var disabledReason;
    if (requiresQuoteChoice) {
        disabledReason = Utils_1.AcceptFormDisabledReason.RequiresQuote;
    }
    if (isCollaboratorPage) {
        disabledReason = Utils_1.AcceptFormDisabledReason.CollaboratorPage;
    }
    if (isTemplateGallery) {
        disabledReason = Utils_1.AcceptFormDisabledReason.TemplateGallery;
    }
    return (react_1.default.createElement(AcceptFlowContextProvider_1.AcceptFlowContextProvider, { settings: settings, autofillEnabled: autofillEnabled, isPreviewAccept: isPreviewAccept, payNowEnabled: payNowEnabled, incompleteAccepterCount: incompleteAccepterCount, postAcceptRedirectUrl: postAcceptRedirectUrl, auditTrailPdfUrl: auditTrailPdfUrl, optOutSpringboard: optOutSpringboard, isPrintMode: isPrintMode, isSimpleMode: isSimpleMode, telemetry: telemetry, disableFormSubmitReason: disabledReason, accepters: accepters, renderPaymentFormError: renderPaymentFormError, hideHeader: hideHeader },
        react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", className: "react-accept-flow qwilr-font", ref: wrapperRef },
            react_1.default.createElement("div", { className: styles.acceptFlow({ isPrintMode: isPrintMode, isSimpleMode: isSimpleMode }) },
                isPreviewAccept && !isSimpleMode && react_1.default.createElement(PreviewAccept_1.PreviewAcceptBanner, { useExtraSpacing: screen === AcceptScreen.Done }),
                screen === AcceptScreen.Form && (react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                        return payNowEnabled ? (react_1.default.createElement(StripeContext_1.StripeEnabledContextProvider, { stripePublicKey: stripePublicKey, stripeUserId: stripeUserId }, children)) : (react_1.default.createElement(StripeContext_1.StripeDisabledContextProvider, null, children));
                    } },
                    react_1.default.createElement(FormScreen_1.FormScreen, { onClose: onClose, onSubmit: onSubmitForm, onFinaliseForm: function () {
                            setIncompleteAccepterCount(Math.max(incompleteAccepterCount - 1, 0));
                            setScreen(AcceptScreen.Done);
                        }, accepterName: accepterName, accepterIndex: accepterIndex, onBack: function () { return setScreen(startScreen); }, consumerDataServiceUrl: consumerDataServiceUrl }))),
                screen === AcceptScreen.Group && (react_1.default.createElement(GroupAcceptScreen_1.GroupAcceptScreen, { onAccepterClick: handleAccepterClick, openPayNowForm: function () { return setScreen(AcceptScreen.PaymentDetails); }, onClose: onClose })),
                screen === AcceptScreen.Done && (react_1.default.createElement(DoneScreen_1.DoneScreen, { onClose: function () {
                        onClose();
                    } })),
                screen === AcceptScreen.PaymentDetails && payNowEnabled && (react_1.default.createElement(StripeContext_1.StripeEnabledContextProvider, { stripePublicKey: stripePublicKey, stripeUserId: stripeUserId },
                    react_1.default.createElement(PaymentDetailsScreen_1.PaymentDetailsScreen, { onCloseForm: onClose, onBack: function () {
                            setScreen(startScreen);
                        }, onSubmit: function () {
                            setScreen(AcceptScreen.PaymentDetailsDone);
                        } }))),
                screen === AcceptScreen.PaymentDetailsDone && (react_1.default.createElement(PaymentDetailsScreen_1.PaymentDetailsDoneState, { onClose: function () {
                        setScreen(startScreen);
                    } })),
                isPreviewAccept && react_1.default.createElement(PreviewAccept_1.default, { onClick: onClose })))));
};
exports.AcceptFlow = AcceptFlow;
